import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;
`;
